// extracted by mini-css-extract-plugin
export default {"title":"R3-z","warning":"S3-z","sizeOptionsLegendText":"T3-z"};